import { ArrowUpRight } from "lucide-react";

const VARIANTS = {
  primary:
    "text-[#0C0C0C] bg-[image:var(--gradient-cta)] hover:brightness-[1.05] shadow-[var(--shadow-warm)]",
  secondary:
    "text-[var(--text-primary)] bg-[rgba(255,245,230,0.04)] border border-[var(--border-subtle)] hover:border-[var(--border-hover)] hover:bg-[rgba(255,245,230,0.07)]",
  outline:
    "text-[var(--text-primary)] bg-transparent border border-[var(--border-subtle)] hover:border-[var(--border-hover)] hover:bg-[rgba(255,245,230,0.04)]",
};

// Reusable rounded pill button. Renders <a> when href is provided, else <button>.
export const PillButton = ({
  children,
  variant = "primary",
  href,
  icon: Icon = ArrowUpRight,
  showIcon = true,
  className = "",
  ...props
}) => {
  const Tag = href ? "a" : "button";
  const anchorProps = href
    ? { href, ...(href.startsWith("http") || href.startsWith("https") ? { target: "_blank", rel: "noopener noreferrer" } : {}) }
    : { type: "button" };

  return (
    <Tag
      {...anchorProps}
      {...props}
      className={`group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold tracking-[0.02em] font-inter cursor-pointer select-none active:scale-[0.98] focus-ring transition-[background-color,border-color,filter,box-shadow] duration-200 ${VARIANTS[variant]} ${className}`}
    >
      {children}
      {showIcon && Icon && (
        <Icon
          size={17}
          className="transition-transform duration-200 group-hover:translate-x-[2px] group-hover:-translate-y-[2px]"
        />
      )}
    </Tag>
  );
};
